import { render, staticRenderFns } from "./MLumProxyDetails.vue?vue&type=template&id=7cb98e38&lang=pug&"
import script from "./MLumProxyDetails.vue?vue&type=script&lang=js&"
export * from "./MLumProxyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports